import React from 'react';
import TOLogo from '../../../../static/images/TO/toyota-logo.svg'
import Row from 'react-bootstrap/Row'
import Image from 'react-bootstrap/Image'
import Button from 'react-bootstrap/Button'
import AppVars from '../../../../AppVars';
import Logger from '../../../../Logger';

let appVars = AppVars.getInstance()
let logger = Logger.getInstance()

class JoinNowView extends React.Component{
    constructor(props){
        super(props);
        this.state ={

        }
    }

    componentDidMount(){
        logger.log('stage', this.props.style)
        logger.log('stage', appVars.getRegisterURL(this.props.style))
    }

    render(){
        return (
            <div>
            <div className = "justify-content-center line-box">
                <div role = "banner">
                    <Row className = "">
                        <a href = {appVars.getAppHomeURL(this.props.style)}><Image className = "corner-logo absolute" alt = "Toyota" src={require('../../../../static/images/Toyota-Logo.svg').default} /></a>
                    </Row>
                </div>
                <div role = "main">
                    <Row className = "justify-content-center location">
                        <div>Registration</div>
                    </Row>
                    <Row className = "title__TO left">New User</Row>
                    <Row className = "justify-content-center text__TO">
                        Your email <b>{this.props.username}</b> hasn't been registered with {this.props.style === "TO" ? "Toyota Owners" : "Toyota"}. Join today to stay up to date with important vehicle notifications, maintenance tips, and safety alerts.
                    </Row>
                    <div style = {{'height' : '56px'}}>
                    </div>
                    <div style = {{'display' : 'grid', 'grid-template-rows' : '60px', 'grid-template-columns' : '184px', 'margin-left' : '-4px', 'marginBottom' : '16px'}}>
                    <a tabIndex = {-1} href= {appVars.getRegisterURL(this.props.style)}><Button tabIndex = {0} data-testid = "JoinNowButton" bsPrefix = "button__TO join-button__TO" type = "button" onClick = {this.props.saveURI} >Join {this.props.style === "TO" ? "Toyota Owners" : "Toyota"}</Button></a>
                    </div>
                </div>
            </div>
            <div className = "code-bottom" role = "complementary">
            <div className = "code-bottom-title join-bottom"><span className = "sign-in">Still having trouble?</span>
            <br className = "mobile-br" />
            <div>
                <a className = "bottom-link" href="/">Try a Different Sign In<img src={require('../../../../static/images/arrow.png')} alt="arrow" className='arrow-right' width="15px"/></a>
                <a className = "bottom-link bottom-link-right" href={appVars.getSupportURL(this.props.style)}>Support<img src={require('../../../../static/images/arrow.png')} alt="arrow" className='arrow-right' width="15px"/></a>
            </div>
            </div> 
        </div>
          </div>
        )
  }
}

export default JoinNowView;